<template>
    <div
        @click="createBP"
        class="flex flex-col justify-between max-w-lg mx-4 mt-2 mb-10 overflow-hidden text-center text-blue-600 rounded-lg shadow cursor-pointer lg:mx-12 min-w-1/4 hover:bg-blue-600 hover:text-white"
        @mouseover="hover = true"
        @mouseleave="hover = false"
    >
        <h1 class="pt-4 mt-4 text-xl font-bold ">{{ title }}</h1>
        <div>
            <div
                class="h-3 mx-20 mb-6 -mt-2 border-b-4 rounded "
                :class="[hover ? 'border-white' : 'border-blue-600']"
            ></div>
            <p class="mx-4 mt-12 mb-10 text-lg leading-loose text-center">
                <slot name="first-Paragraph"></slot>
                <br class="hidden lg:inline" />
                <slot name="second-Paragraph"></slot>
                <br class="hidden lg:inline" />
                <slot name="third-Paragraph"></slot>
            </p>
        </div>
        <div
            class="flex items-center justify-center h-12 "
            :class="[hover ? 'bg-white ' : 'bg-blue-600']"
        >
            <button
                class="text-lg font-bold  focus:outline-none"
                :class="[hover ? 'text-blue-600' : 'text-white']"
            >
                Créer
            </button>
        </div>
        <!-- <div class="overflow-hidden rounded-lg shadow-lg">
    <div class="px-6 py-8 bg-white sm:p-10 sm:pb-6">
      <div>
        <span
          class="inline-flex px-4 py-1 text-sm font-semibold leading-5 tracking-wide text-blue-600 uppercase bg-blue-100 rounded-full"
        >
          {{ title }}
        </span>
      </div>
      <div
        class="flex items-baseline mt-4 text-6xl font-extrabold leading-none"
      > -->
        <!-- {{ title }} -->

        <!-- <span class="ml-1 text-2xl font-medium leading-8 text-gray-500"> </span>
      </div>
      <p class="mt-5 text-lg leading-7 text-gray-500">
        Lorem ipsum dolor sit amet consectetur, adipisicing elit.
      </p>
    </div>
    <div class="px-6 pt-6 pb-8 bg-gray-50 sm:p-10 sm:pt-6">
      <ul>
        <li class="flex items-start">
          <div class="flex-shrink-0">
            <svg
              class="w-6 h-6 text-green-500"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p class="ml-3 text-base leading-6 text-gray-700">
            Pariatur quod similique
          </p>
        </li>
        <li class="flex items-start mt-4">
          <div class="flex-shrink-0">
            <svg
              class="w-6 h-6 text-green-500"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p class="ml-3 text-base leading-6 text-gray-700">
            Sapiente libero doloribus modi nostrum
          </p>
        </li>
        <li class="flex items-start mt-4">
          <div class="flex-shrink-0">
            <svg
              class="w-6 h-6 text-green-500"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p class="ml-3 text-base leading-6 text-gray-700">
            Vel ipsa esse repudiandae excepturi
          </p>
        </li>
        <li class="flex items-start mt-4">
          <div class="flex-shrink-0">
            <svg
              class="w-6 h-6 text-green-500"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
          <p class="ml-3 text-base leading-6 text-gray-700">
            Itaque cupiditate adipisci quibusdam
          </p>
        </li>
      </ul>
      <div class="mt-6 rounded-md shadow">
        <a
          href="#"
          class="flex items-center justify-center px-5 py-3 text-base font-medium leading-6 text-white transition duration-150 ease-in-out bg-gray-900 border border-transparent rounded-md hover:bg-gray-800 focus:outline-none focus:shadow-outline"
        >
          Créer
        </a>
      </div>
    </div>
  </div> -->
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true,
            default: "Version Détaillée"
        }
    },
    data() {
        return {
            hover: false
        };
    },
    methods: {
        createBP() {
            if (this.title === "Version Simplifiée")
                this.$store.dispatch(
                    "user/setBpiVersion",
                    "Version Simplifiée"
                );
            this.$store.dispatch("user/createBPDetailed");
        }
    }
};
</script>

<style></style>
